import { Footer } from '../shared'

export const DashboardFooter = ({ className }) => (
  <Footer className={className} variant='light' showSocials={false} />
)
